var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftThin = function SvgArrowLeftThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1.266 8.863 6.187-6.187c.211-.211.598-.211.809 0 .21.21.21.597 0 .808L3.023 8.688h13.29c.28 0 .562.28.562.562a.58.58 0 0 1-.562.563H3.023l5.239 5.238c.21.21.21.597 0 .808a.596.596 0 0 1-.809 0L1.266 9.672a.596.596 0 0 1 0-.809"
  })));
};
export default SvgArrowLeftThin;